module.exports = __webpack_public_path__ + "media/icons/1@3x-e5ac85e6.svg";